// Selbe Symbol-/Farbsprache wie die großen System-Dialoge (Fehler/Warnung/Erfolg, siehe
// Dienstplaner.html #keine-bereiche-dialog/#warnung-schicht-copy-dialog/#erfolg-schicht-copy-dialog)
// — deren Icon-Farben sind bereits global in dienstplan.css definiert (.bi-exclamation-octagon-fill,
// .bi-exclamation-triangle-fill, .bi-shield-fill-check), hier nur wiederverwendet.
const NACHRICHT_TYPEN = {
	'-1': { klasse: 'nachricht-fehler', icon: 'bi-exclamation-octagon-fill' },
	0: { klasse: 'nachricht-warnung', icon: 'bi-exclamation-triangle-fill' },
	1: { klasse: 'nachricht-erfolg', icon: 'bi-shield-fill-check' },
};

/**
 * Zeigt eine kleine Systeminfo an den User, die nach 5 Sekunden automatisch verschwindet
 * @param {string} inhalt
 * @param {int} type -1 = Error, 0 = Warning, 1 = Success
 */
function zeigeKleineNachricht(inhalt, type = 0) {
	const template = document.querySelector('[kleine-system-nachricht-template]');
	const feed = document.getElementById('nachrichten-feed');
	const nachrichtDiv = template.content.cloneNode(true).children[0];
	const { klasse, icon } = NACHRICHT_TYPEN[type] ?? NACHRICHT_TYPEN[0];
	nachrichtDiv.className = klasse;
	const iconEl = document.createElement('i');
	iconEl.className = `bi ${icon}`;
	const textEl = document.createElement('span');
	textEl.innerText = inhalt;
	nachrichtDiv.appendChild(iconEl);
	nachrichtDiv.appendChild(textEl);
	feed.appendChild(nachrichtDiv);
	// Einblenden der Nachricht mit Animation
	setTimeout(() => {
		nachrichtDiv.classList.add('zeigen');
	}, 100);
	// Ausblenden der Nachricht nach 3 Sekunden
	setTimeout(() => {
		nachrichtDiv.classList.remove('zeigen');
		nachrichtDiv.ontransitionend = () => nachrichtDiv.remove();
	}, 3500);
}

export { zeigeKleineNachricht };
